import { Search, BarChart3, Library, Target, Settings, Home, Dices, FileText, Star, Check, ArrowUp, ArrowDown, CheckCircle2, XCircle, AlertTriangle, Info, Bell, User, Users, Calendar, Timer, Heart, ThumbsUp, ThumbsDown, Meh, Package, Store, ShoppingCart, Gamepad2, PoundSterling, ShoppingBag, Smartphone, Tag, Lightbulb, HelpCircle, X, Circle, BookOpen, Ban, ScanSearch, ExternalLink } from "lucide-react";

/**
 * Icon constants for use across the application
 * Centralizes lucide-react icon definitions for consistency
 */

// Navigation icons
export const TIMELINE_ICON = <BarChart3 size={20} strokeWidth={2.5} />;
export const COLLECTION_ICON = <Library size={20} strokeWidth={2.5} />;
/** Library / collection (same as nav "Library") */
export const LIBRARY_ICON = COLLECTION_ICON;
export const JET_SET_GO_ICON = <Target size={20} strokeWidth={2.5} />;
export const ADMIN_ICON = <Settings size={20} strokeWidth={2.5} />;
export const HOME_ICON = <Home size={20} strokeWidth={2.5} />;
export const EXPLORE_ICON = <Search size={20} strokeWidth={2.5} />;

// Feature icons
export const GAME_ICON = <Dices size={16} />;
export const SESSION_ICON = <FileText size={16} />;
export const RATING_ICON = <Star size={16} className="pista-icon" />;

// Action icons
export const CHECK_ICON = <Check size={16} />;
export const ARROW_UP_ICON = <ArrowUp size={16} />;
export const ARROW_DOWN_ICON = <ArrowDown size={16} />;

// Status icons
export const SUCCESS_ICON = <CheckCircle2 size={16} />;
export const ERROR_ICON = <XCircle size={16} />;
export const WARNING_ICON = <AlertTriangle size={16} />;
export const INFO_ICON = <Info size={16} />;
export const NOTIFICATION_ICON = <Bell size={16} />;

// Player icons
export const USER_ICON = <User size={20} strokeWidth={2.5} />;
export const GROUP_ICON = <Users size={16} />;

// Time icons
export const CALENDAR_ICON = <Calendar size={16} />;
export const TIMER_ICON = <Timer size={16} />;

// Preference/Rating icons
export const HEART_ICON = <Heart size={16} className="pista-icon" />;
export const THUMBS_UP_ICON = <ThumbsUp size={16} className="pista-icon" />;
export const THUMBS_DOWN_ICON = <ThumbsDown size={16} className="pista-icon" />;
export const NEUTRAL_ICON = <Meh size={16} className="pista-icon" />;

// Platform icons
export const AMAZON_ICON = <Package size={16} />;
export const EBAY_ICON = <Store size={16} />;
export const GEEKMARKET_ICON = <Dices size={16} />;
export const WALLAPOP_ICON = <ShoppingCart size={16} />;
export const BGA_ICON = <Gamepad2 size={16} />;
export const BOARDGAMEPRICES_ICON = <PoundSterling size={16} />;
export const SHOPPING_ICON = <ShoppingBag size={16} />;
export const MOBILE_PHONE_ICON = <Smartphone size={16} strokeWidth={2.5} />;

// Feature type icons
export const MECHANICS_ICON = <Settings size={16} />;
export const CATEGORIES_ICON = <Tag size={16} />;

// Insight/Analytics icons
export const SEARCH_ICON = <Search size={16} />;
export const TARGET_ICON = <Target size={16} />;
export const ACTIVITY_ICON = <FileText size={16} />;
export const CTA_ICON = <Lightbulb size={16} />;

// Share/Export icons
export const CHART_ICON = <BarChart3 size={16} />;

// UI control icons
export const SETTINGS_ICON = <Settings size={16} />;
export const HELP_ICON = <HelpCircle size={16} />;
export const CLOSE_ICON = <X size={18} />;

// Additional status/control icons
export const INACTIVE_ICON = <Circle size={16} />;
export const COLLECTION_BOOK_ICON = <BookOpen size={16} />;
export const EXCLUDE_ICON = <Ban size={16} />;

// Game preview header action icons
export const FIND_SIMILAR_ICON = <ScanSearch size={18} strokeWidth={2} />;
export const OPEN_IN_EXPLORE_ICON = <ExternalLink size={18} strokeWidth={2} />

// Default icon set for easy import
export const ICONS = {
  TIMELINE: TIMELINE_ICON,
  COLLECTION: COLLECTION_ICON,
  JET_SET_GO: JET_SET_GO_ICON,
  ADMIN: ADMIN_ICON,
  HOME: HOME_ICON,
  EXPLORE: EXPLORE_ICON,
  GAME: GAME_ICON,
  SESSION: SESSION_ICON,
  RATING: RATING_ICON,
  CHECK: CHECK_ICON,
  ARROW_UP: ARROW_UP_ICON,
  ARROW_DOWN: ARROW_DOWN_ICON,
  SUCCESS: SUCCESS_ICON,
  ERROR: ERROR_ICON,
  WARNING: WARNING_ICON,
  INFO: INFO_ICON,
  NOTIFICATION: NOTIFICATION_ICON,
  USER: USER_ICON,
  GROUP: GROUP_ICON,
  CALENDAR: CALENDAR_ICON,
  TIMER: TIMER_ICON,
  HEART: HEART_ICON,
  THUMBS_UP: THUMBS_UP_ICON,
  THUMBS_DOWN: THUMBS_DOWN_ICON,
  NEUTRAL: NEUTRAL_ICON,
  AMAZON: AMAZON_ICON,
  EBAY: EBAY_ICON,
  GEEKMARKET: GEEKMARKET_ICON,
  WALLAPOP: WALLAPOP_ICON,
  BGA: BGA_ICON,
  SHOPPING: SHOPPING_ICON,
  MOBILE_PHONE: MOBILE_PHONE_ICON,
  MECHANICS: MECHANICS_ICON,
  CATEGORIES: CATEGORIES_ICON,
  SEARCH: SEARCH_ICON,
  TARGET: TARGET_ICON,
  ACTIVITY: ACTIVITY_ICON,
  CTA: CTA_ICON,
  CHART: CHART_ICON,
  SETTINGS: SETTINGS_ICON,
  HELP: HELP_ICON,
  CLOSE: CLOSE_ICON,
  INACTIVE: INACTIVE_ICON,
  COLLECTION_BOOK: COLLECTION_BOOK_ICON,
  EXCLUDE: EXCLUDE_ICON,
  FIND_SIMILAR: FIND_SIMILAR_ICON,
  OPEN_IN_EXPLORE: OPEN_IN_EXPLORE_ICON,
};

export default ICONS;